import { useState, useContext, useRef, useEffect } from "react";
import $ from "jquery";
import {scriptControlHeight, mediaControlHeight, unsupportedFormats, dBConn} from '../ApiCenter/API_GET'

import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from 'wavesurfer.js/src/plugin/regions/index.js'
import MarkersPlugin from 'wavesurfer.js/src/plugin/markers/index.js'

//import TimelinePlugin from 'wavesurfer.js/src/plugin/timeline/index.js'
/*import Minimap from 'wavesurfer.js/src/plugin/minimap/index.js'*/

import path from 'path-browserify';
import  {InfoContext}  from '../ApiCenter/AM_BackGroundOP';
import Protected from "../Protected";
import "./AudioMatePlayer.css";



let fileplaying = '';
let forceplaying = '';
let switchQuality = 0
let checkSwitchQuality = 0
let autoPlayEnabled = false;
let wavesurfer
let s3fullpath
let xlocDataObj
let enableDownload = false
let audioUrl
let previousAudioUrl
let loop = false
let previousZoomValue = 0
let numChannels = false
let PlayerHeight

let rememberData
let zoomMax = 1000

let playbackFinished

let useHQFiles = true;
let allowMarkersVar = 0;
let howManyMarkerAtTheBegin 
let portal = false

export const AudioMatePlayer = (props) => {
    
    const [playList, setPlayList] = useState([])
    const [floatable, setFloatable] = useState('')
    //const [draggable, setDraggable] = useState(true)
    const [position, setPosition] = useState({ x: 300, y: 200 });

    portal = props.portal

    const nodeRef = useRef(null);

    const altKey = useRef(false)
    // eslint-disable-next-line
    const ctx = useContext(InfoContext);

    useEffect(() => {
        
        function recallPlayList(){
            setPlayList(eleboratePlayList(props.playList, 0))
            setFloatable('floatable')
            //setDraggable(false)
            if(props.playList.length > 0){
                if(props.playList[0].type_name === 'xloc') {
                    const fileName = props.playList[0].s3_source_filename?.locId + '/source';
                    const xlocData = props.playList[0].s3_source_filename;
                    xlocData.languageId = 'source';
                    xlocData.request = 2;
                    playAudio(fileName, props.playList[0].type_name, props.playList[0].audiobase_link, 60, false, false,false, [], false, null, xlocData)
                } else {
                    playAudio(`projects-audiomate/project-${props.playList[0].s3_source_filename}`, props.playList[0].type_name, props.playList[0].audiobase_link, 60) 
                }               
            }
        } 

        try{
            if(props.playList.length > 0){
                recallPlayList()
            }
        } catch(e){}

    }, [props])

    useEffect(() => {
        
        window.addEventListener('load', handleCompleteLoad);
        window.addEventListener('message', handleMessage);
        window.addEventListener('wheel', wheelZoom);
        window.addEventListener('resize', function(){

            if(wavesurfer && document.getElementById('playerContainer')){
                const widndowHeight = $(window).height();
                if(document.getElementById('playerContainer').classList.contains('fullpage')){
                    //
                    //wavesurfer.drawBuffer();
                    redrawWaveform();  
                }

                let reduceOf = 125

                if(document.getElementById('playerContainer').classList.contains('portal')){

                    if(document.getElementById('markerListPanel').style.display !== 'none'){
                        reduceOf = reduceOf + 160
                    }

                    let playerHeight = widndowHeight - reduceOf
                    //if(isStereo){
                        playerHeight = playerHeight/numChannels
                    //}
                    wavesurfer.setHeight(playerHeight)
                    $('#waveform').height(widndowHeight - reduceOf)
                    //wavesurfer.drawBuffer(); 
                    redrawWaveform(); 
                }
            }
        });

        window.addEventListener('beforeunload', () => {
            interactionWithScript({action: {type: 'destroy'}})
        });

        window.addEventListener('keydown', playerKeyDown);
        window.addEventListener('keyup', playerKeyUp);

        return () => {
            window.removeEventListener('wheel', wheelZoom);
            window.removeEventListener('keydown', playerKeyDown);
            window.removeEventListener('keyup', playerKeyUp);
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('load', handleCompleteLoad);
            try{wavesurfer.destroy()}          
            catch(e){}
        } 
    // eslint-disable-next-line
    }, [])

    // messages that Player receives when is detached
    const handleMessage = (props) => {

        if(props.data.playInfo){
            let info = props.data.playInfo;
            useHQFiles = info.quality === 'hiquality'
            allowMarkersVar = info.allowMarkers ?? 0

            parsePlayAudio(info)
            rememberData = {
                s3filename: info.s3filename, 
                type: info.type,
                realFilename: info.realFilename,
                height: info.height, 
                fromManualPlay: info.fromManualPlay,
                localAudio: info.localAudio,
                markers: info.markers,
                allowMarkers: allowMarkersVar,
                xlocData: info.xlocData,
            }
        }
        
        if(props.data.control){
            let control = props.data.control
            if(control === 'amplayerBackward'){
                playerBackward()
            }
            if(control === 'playPause'){
                playerPlayPause()
            }
            if(control === 'isAutoPlay'){
                if($('.autoplay').is('.active')){
                    interactionWithScript({action: {type: 'autoplay', value: $('#referenceType').val()}})
                } else {
                    interactionWithScript({action: {type: 'autoplay', value: false}})
                }
            }
        }
    }

    const handleCompleteLoad = () => {
        if(rememberData){
            playAudio(rememberData.s3_source_filename.replace('projects-audiomate/', ''), rememberData.type_name, rememberData.audiobase_link, rememberData.height )
        }
    }

    const playerKeyDown = (event) => {

        if(document.getElementById('playerContainer').classList.contains('portal')){   
            if(event.key === '-'){
                amplayerBackward()
            }            
        }
        if(event.key === 'Alt'){
            if(!altKey.current){
                altKey.current = true
            } 
        }
        if(event.key === 'Insert'){
            if(allowMarkersVar === 0){
                return
            }
            createNewMarker()           
        }

        if(event.key === 'Enter' ){
            const newMarker = document.getElementById('newMarker');
            if (newMarker) {
                newMarker.blur();
            }
        }
    }

    const interactionWithScript = (props) => {
        if(document.getElementById('playerContainer').classList.contains('portal')){
            window.postMessage(props, '*');
        }
    }

    const playerKeyUp = (event) => {
        if(document.getElementById('playerContainer').classList.contains('portal')){   
            if(event.key === ' '){
                playerPlayPause()
                //interactionWithScript({action: {type: 'keydown', value: 'Space'}})
            }
        }  
        if(event.key === 'Alt'){
            altKey.current = false
        } 
    }

    function changePositionPlayer(){

        var playerContainer = document.getElementById('playerContainer');    
        if(altKey.current && !playerContainer.classList.contains('portal')){
            altKey.current = false
            wavesurfer.stop()
            try{
                props.onDetachState(rememberData)  
                return
            } catch(e){}
     
        }

        if(playerContainer.classList.contains('fullpage')){

            playerContainer.classList.remove('fullpage');
            
            if(loop){
                loopAudio()
            }
            PlayerHeight = 23

            try{

                //if(isStereo){
                    wavesurfer.setHeight(PlayerHeight / numChannels);
                /*} else {
                    wavesurfer.setHeight(PlayerHeight);
                }*/
            }
            catch(e){}
        } else {        
            playerContainer.classList.add('fullpage');
            PlayerHeight = 60
            try {
                //if(isStereo){
                    wavesurfer.setHeight(PlayerHeight / numChannels);
                /*} else {
                    wavesurfer.setHeight(PlayerHeight);
                }*/
            }
            catch(e){}
        }
        wavesurfer.zoom(0)
        previousZoomValue = 0
        //wavesurfer.drawBuffer();
        redrawWaveform(); 
        var zoom = document.getElementById('zoomSlider');
        zoom.value = 40;
        try{
            wavesurfer.seekTo(wavesurfer.getCurrentTime() / wavesurfer.getDuration());
        }
        catch(err){}
        
        scriptControlHeight('none')
        mediaControlHeight()
    }

    function autoPlay(){

        var autoplayElement = document.querySelector('.autoplay');
        if(autoplayElement.classList.contains('active')){
            autoplayElement.classList.remove('active');
            autoPlayEnabled = false;
            interactionWithScript({action: {type: 'autoplay', value: false}})
        } else {
            autoplayElement.classList.add('active');
            autoPlayEnabled = true;
            interactionWithScript({action: {type: 'autoplay', value: $('#referenceType').val()}})
        }
    }

    
    const wheelZoom = (props) => {

        if(props.target.localName === 'wave'){
            if(!$('#playerContainer').is('.portal, .fullpage')){
                return 
            }
            const maximum = zoomMax
            const steps = parseInt(maximum / 12)
            const zoomSlider = $('#zoomSlider')
            let value = parseInt(zoomSlider.val());
            if(props.deltaY > 0){
                value -= steps;
            } else {
                value += steps;               
            }
    
            if(value > maximum){
                value = maximum
            } else if(value < 0){
                value = 0
            }    
            if(previousZoomValue !== value){
                wavesurfer.zoom(Number(value));
                zoomSlider.val(value);
                previousZoomValue = value
            }  
        }
     
    }

    const Zoom = (props) => {
        function changeZoomValue(value){
            wavesurfer.zoom(Number(value));
        }

        return (
            <div id="zoomSliderBox">
                <i className="bi bi-zoom-out" style={{position: 'relative', fontSize: '12px', top: '-3px'}}></i>
                <input id="zoomSlider" type="range" min="0" max="10000" step="1"
                onChange={(event) => {changeZoomValue(event.target.value)}} />
                <i className="bi bi-zoom-in" style={{position: 'relative', fontSize: '12px', top: '-3px'}}></i>
             </div>
        );
    }



    const VZoom = () => {
        let zoomVTimeout;
        //var zoomV = document.getElementById('zoomVerticalSlider');

        function verticalZoom(value){

          clearTimeout(zoomVTimeout);
          zoomVTimeout = setTimeout(function(){

            const currentPosition = wavesurfer.getCurrentTime();
            const isPlaying = wavesurfer.isPlaying()

                wavesurfer.params.barHeight = value
                wavesurfer.empty();

                //wavesurfer.drawBuffer();
                redrawWaveform(); 
               
                if(isPlaying){
                    wavesurfer.setCurrentTime(currentPosition);
                    wavesurfer.play();
                }
          }, 50);
        }
      
        return (
            <div id="zoomVerticalSliderBox">
                <i className="bi bi-soundwave" style={{position: 'relative', fontSize: '12px', top: '-3px'}}></i>
                <input id="zoomVerticalSlider" type="range" min="1" max="10" step="1" 
                onChange={(event) => {verticalZoom(event.target.value)}} />
                <i className="bi bi-soundwave" style={{fontSize: '18px', position: 'absolute', top: '-2px'}}></i>
            </div>
        );
    };

    const changeType = (props) => {
        //console.log("PROPS", props.target.value)
    }

    try{
        wavesurfer.on('finish', function (){})
    }
    catch(e){}

    const playPlaylist = (props) => {

        let item = playList[props]
        /* remove all active */
        let replaceActive = playList.map((item, index) => {
            if(index === props){
                item.active = true
                return item
            }
            item.active = false
            return item
        })
        setPlayList(replaceActive);
        
        if(item.type_name === 'xloc') {
            const fileName = item.s3_source_filename?.locId + '/source';
            const xlocData = item.s3_source_filename;
            xlocData.languageId = 'source';
            xlocData.request = 2;
            playAudio(fileName, item.type_name, item.audiobase_link, 60, false, false,false, [], false, null, xlocData);
        } else {
            playAudio(`projects-audiomate/project-${item.s3_source_filename}`, item.type_name, item.audiobase_link);
        }               

    }

    const closePlayer = () => {
        try{wavesurfer.destroy()}
        catch(e){}
        $('#playerContainer').fadeOut(300, function(){
            setPlayList([])
            setFloatable('')
            props.removePlaylist()
        });
    }

    const downloadFile = async () => {

        var filename = document.getElementById('filename').textContent;
        var extension = !xlocDataObj ? path.parse(s3fullpath).ext : "";
        var arrayOfFiles = [{to: filename + extension, from: !xlocDataObj ? s3fullpath.replace('projects-audiomate/project-', '') : xlocDataObj}]
        try {
            ctx.setInfoData({
                ...ctx.info.current,
                download: {
                    status: 'preparing',
                    outputFilename: filename + extension, // or nothing for tak the original name  
                    fileList: arrayOfFiles, // just one object in the array, // just one object in the array
                    message: 'Preparing download...'
                }
            })
        } catch (error) {
            console.log("ERR")
        } 
    }

    const handleMouseDown = (e) => {
        e.preventDefault();
        const initialMouseX = e.clientX;
        const initialMouseY = e.clientY;
        const initialElementX = position.x;
        const initialElementY = position.y;

        const handleMouseMove = (e) => {
            const deltaX = e.clientX - initialMouseX;
            const deltaY = e.clientY - initialMouseY;

            setPosition(prevSettings => ({
                x: initialElementX + deltaX,
                y: initialElementY + deltaY
            }));
        }

        const handleMouseUp = () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    }

    const saveNewMarkers = () => {

        const button = $('#saveMarkersButton')
        button.addClass('disabled');
        button.text('Saving...')
        button.append('<div class="spinner-border text-light" role="status">' + 
                        '<span class="visually-hidden">Loading...</span>' + 
              '</div>')
    
        const infoToSave = {
            fullPath: rememberData.s3filename,
            markers: JSON.stringify(wavesurfer.markers.markers.map((marker, idx) => {
                return {
                    time: marker.time,
                    label: marker.label,
                    id: idx + 1
                }    
            }))
        }

        if(document.getElementById('playerContainer').classList.contains('portal')){
            interactionWithScript({action: {type: 'saveMarkers', value: infoToSave}})
        } else {
            props.updateMarkers(infoToSave)
        }

        dBConn.post('audioSaveMarkers', infoToSave).then(res => {
            hideSaveButton(true);
        })
    }

    return (
    <>

            <div id="playerContainer" className={`${floatable}`} ref={nodeRef} style={playList.length !== 0 ? {left: position.x, top: position.y} : {}} >
                {playList.length !== 0 && 
                    <div className="playListHeader" onMouseDown={handleMouseDown}>Samples Audio Player</div>
                }
                {/*props.markers && */props.portal && <div id="markerListPanel">
                            <div className="head">Markers <button title="Close Markers Panel" type="button" className="btn closeMarkersModal" onClick={() => openCloseMarkersWindow()}>🗙</button></div>
                            <div className="markerList">
                                {<table className="table table-sm">
                                    <tbody>
                                    </tbody>
                                </table>}
                            </div>
                            <div className="defaultName">
                                Default name <input id="markerNameDefault" className="form-control" type="text" />
                            </div>
                        </div>
                }

                
                <div className="infofile">
                    <div id="filename">Player</div>
                    <select id="referenceType" className="form-select form-select-sm" onChange={changeType}>               
                        <option value="0.5">Reference</option>
                    </select>
                    <Protected returnNull={true} permissions={['SourceDownloadFiles', 'TargetDownloadFiles']} >
                        <i className="bi bi-cloud-download-fill downloadHandler" onClick={downloadFile} title="Download file"></i>
                    </Protected>
                    <div id="sliderPlace">
                        <Zoom zoomValue={zoomMax} />
                        <VZoom />
                        <div id="availableFormats"></div>
                    </div>
                    
                    
                    <div id="playerTimes">
                        <div id="regionTime" style={{color: '#fff'}}></div>
                        <div id="timer" style={{color: '#fff'}}>Position: <span id="timercursor">---</span></div>
                        <div id="duration" style={{color: '#fff'}}>Duration: <span id="timeDuration">---</span></div>
                    </div>
                    
                    
                </div>
                <div id="playerControls">
                    <button className="btn btn-sm b-skipstart" title="Go to start ( - on keyboard )" onClick={() =>playerBackward()}>
                            <i className="bi bi-skip-start"></i>
                    </button>
                    <button className="btn btn-sm b-stop" title="Stop" onClick={() =>playerStop()}>
                        <i className="bi bi-stop"></i>
                    </button>
                    <button id="PlayButton" className="btn btn-sm b-play" title="Play/Pause ( Space on keyboard )" onClick={() =>playerPlayPause()}>
                        <i id="changeIconPlayer" className="bi bi-play"></i>
                    </button>
                    <button id="loopBotton" className="btn btn-sm b-play" title="Loop" onClick={() =>loopAudio()}>
                        <i className="bi bi-arrow-repeat"></i>
                    </button>
                    {playList.length === 0 &&
                        <button className="btn btn-sm autoplay" title="Auto-Play" onClick={() =>autoPlay()}><i className="bi bi-collection-play"></i></button>
                    }
                    
                </div>
                {/*props.markers && */props.portal && <i title="Markers Panel" id="markerListIcon" className="bi bi-bookmark-check" onClick={() => openCloseMarkersWindow()}></i>}
                
                <div id="waveformplace" >
                    <div id="loadingWaveform" style={{display: 'none'}}>Loading...</div>
                    <div id="waveform" onDoubleClick={() => wavesurfer.play()}></div>
                </div>
                {playList.length === 0 ?
                    <>{/*props.markers && */!props.portal &&
                        <><div id="markerListPanel">
                            <div className="head">Markers <button title="Close Markers Panel" type="button" className="btn closeMarkersModal" onClick={() => openCloseMarkersWindow()}>🗙</button></div>
                            <div className="markerList">
                                {<table className="table table-sm">
                                    <tbody>
                                    </tbody>
                                </table>}
                            </div>
                            <div className="defaultName">
                                Default name <input id="markerNameDefault" className="form-control" type="text" />
                            </div>
                        </div>
                        <i id="markerListIcon" title="Markers Panel" className="bi bi-bookmark-check" onClick={() => openCloseMarkersWindow()}></i>
                        </>
                    }
                    <div id="fullPageIcon" title="Change position player
                    (or Alt + click to detach the player in separated window)">
                        <i className="bi bi-back" onClick={() =>changePositionPlayer()}></i>
                    </div>
                    </>
                    : 
                    
                    <div id="fullPageIcon" title="Change position player
                    (or Alt + click to detach the player in separated window)">  
                        <span onClick={() =>closePlayer()} style={{paddingRight: '3px', fontWeight: 'bold'}} title="Close the Player">X</span>
                    </div>
                }
                {playList &&
                <div id="audioplayList" style={{color: '#FFF'}}>
                    {playList.map((item, index) => (
                        <div className={item.active === true ? 'audioItem active' : 'audioItem'}
                            key={index} onClick={() => playPlaylist(index)}
                            >
                            <div className="audioItemTitle">
                                <i className="audioItemTitlePlayer bi bi-play"></i> {item.audiobase_link}
                            </div>
                        </div>
                    ))}
                </div>
                }
                <button className="btn btn-sm btn-danger" id="saveMarkersButton" onClick={saveNewMarkers}>Save</button>
            </div>

    </>)
}

function markersEditable(trueFalse, labelName){
    allowMarkersVar = trueFalse
    if(labelName !== null){
        $('#markerNameDefault').val(labelName);      
    } else {
        $('#markerNameDefault').val('');
    }
}


function redrawWaveform() {
    if (wavesurfer) {
        wavesurfer.drawBuffer();
    }
}

let markersArray

export const extractID = (object) => {

    if(object){
        const parse = object.split('/')
        const id = parseInt(parse[parse.length - 1].split('.')[0])
        const type = parse[parse.length - 2]

        return `${id}_${type}`
    }
}



export const parsePlayAudio = (args) => {
    const { s3filename, type, realFilename, height, fromManualPlay, localAudio = undefined, forceFormat = false, markers = null, allowMarkers = 0, defaultMarkerLabel = null, xlocData = null} = args;
    playAudio(s3filename, type, realFilename, height, fromManualPlay, localAudio, forceFormat, markers, allowMarkers, defaultMarkerLabel, xlocData)
}

export const playAudio = (s3filename, type, realFilename, height, fromManualPlay, localAudio = undefined, forceFormat = false, markers = [], allowMarkers, defaultMarkerLabel = null, xlocData = null) => {
    
    if(s3filename === 'projects-audiomate/') s3filename = '';
    markersArray = markers 

    rememberData = {s3filename, type, realFilename, height, fromManualPlay, localAudio, forceFormat, markers, allowMarkers, defaultMarkerLabel, xlocData}      
    if(fileplaying === s3filename && autoPlayEnabled && s3filename !== '' && !fromManualPlay){
        return
    }

    markersEditable(allowMarkers, defaultMarkerLabel)

    $('#playerContainer').fadeIn(300);
    /* set layer loading  */
    const elementLoading = document.getElementById('loadingWaveform');

    if(s3filename === ''){
        elementLoading.innerHTML = '"' + type + '" file missing';
        elementLoading.style.display = 'block'; 
        if(wavesurfer){ 
            wavesurfer.destroy(); 
            playIconDefault() 
        }; 
        fileplaying = ''; 
        return 
    } 


    resetSelectionTime();
    if(fileplaying === s3filename && forceplaying === forceFormat && switchQuality === checkSwitchQuality && !wavesurfer?.isDestroyed){
        playerBackward(); 
        return 
    }

    checkSwitchQuality = switchQuality


    hideSaveButton(false);
    if(wavesurfer){
        wavesurfer.setBackgroundColor('#0e151d');
    }
    elementLoading.innerHTML = `Loading: 0%`;
    elementLoading.style.display = 'block'; 

    fileplaying = s3filename;
    forceplaying = forceFormat;
    let forceHeight = height

    var referenceType = document.getElementById('referenceType');
    referenceType.innerHTML = '';

    var option = document.createElement('option');
    option.textContent = type;
    referenceType.appendChild(option);

    var filename = document.getElementById('filename');
    var manipulateFilename = path.parse(realFilename).name
    filename.textContent = manipulateFilename;
    filename.title = manipulateFilename;

    // set fullpath of the file
    s3fullpath = s3filename;
    xlocDataObj = xlocData
    
    const FetchAudioFile = async () => {
        let Vzoom;
        if(wavesurfer){
            Vzoom = wavesurfer.params.barHeight;
        }
        try{
            wavesurfer.destroy()
        } catch(err){}
        

        const local = localAudio !== undefined ? localAudio : false;

        const params = {
            Key: !xlocData ? s3fullpath.replace('projects-audiomate/projects-audiomate/', 'projects-audiomate/') : s3fullpath,
            local,
            useHQFiles: !useHQFiles,
            forceFormat,
            xlocData: xlocData,
        };
    

        function downloadAudioFile2(params) {
            if (params.local === true) {
              return Promise.resolve(null);
            } else if (params.xlocData) {
                const link = dBConn.post("xlocapi=1", params.xlocData)
                return link
            }
            return dBConn.post('getSingleFile', params);
        }

          
        downloadAudioFile2(params).then((data) => {

            if(!data?.availableFormats) {
                data.availableFormats = ['wav'];
                data.file = true;
                data.link = JSON.parse(data?.audio?.Message ?? '{}')?.URL ?? null;
                data.selectedKey = params.Key; 
            } 
            
            availableFormatsButtons(data.availableFormats, data.selectedKey, s3filename, type, realFilename, height, fromManualPlay, localAudio);
            
            if(data.file === null){
                 return;
            }

            // different colors for original and optimized
            const colors = data.selectedKey === params.Key ? {
                backgroundColor: '#0e151d',
                waveColor: '#a7d4ff',
            } : {
                backgroundColor: '#0e151d',
                waveColor: '#ff8254',
            };

            rememberData.waveColor = colors.waveColor
            rememberData.backgroundColor = colors.backgroundColor
            
            // Revokes the old url if it exists
            if(previousAudioUrl !== undefined){       
                URL.revokeObjectURL(audioUrl);
            }

            if(local !== false){
                audioUrl = local;
                previousAudioUrl = undefined;
            } else {

                audioUrl = data.link
                previousAudioUrl = audioUrl;             
            }

            PlayerHeight = 23
            if(forceHeight !== undefined){
                PlayerHeight = forceHeight
            }
            var playerContainer = document.getElementById('waveform');

            PlayerHeight = playerContainer.clientHeight;

            const MarkersPlug = MarkersPlugin.create()
              
            if(!wavesurfer || wavesurfer.isDestroyed){   
                wavesurfer = WaveSurfer.create({
                    container: '#waveform',
                    splitChannels: true,
                    scrollParent: false,
                    height: PlayerHeight,
                    backgroundColor: colors.backgroundColor,
                    waveColor: colors.waveColor,
                    cursorWidth: 1,
                    cursorColor: '#FFF',
                    plugins: [
                        RegionsPlugin.create({
                            regionsMinLength: 0.01,
                            color: 'rgba(255, 0, 0, 0.5)',
                            dragSelection: {
                                slop: 5,
                                
                            },
                        }),
                        MarkersPlug
                        
                    ]
                });
            } else {
                wavesurfer.waveColor = colors.waveColor;
            }

            wavesurfer.load(audioUrl);

            var timercursor = document.getElementById('timercursor');
            var timeDuration = document.getElementById('timeDuration');

            wavesurfer.on('loading', (percent) => {
                elementLoading.innerHTML = `Loading: ${percent}%`;
            })



            wavesurfer.on('region-update-end', (marker) => {
                const checkMarkersChanged = checkMarkers(wavesurfer.markers.markers, markersArray ?? [])
                //console.log("checkMarkersChanged", checkMarkersChanged)
                if(checkMarkersChanged === 'changed'){
                    notSaved()
                    listOfMarkers()

                    const markerTimes = wavesurfer.markers.markers.map(el => el.time);
                    let foundMatch = 0;
                    Object.values(wavesurfer.regions.list).forEach((region) => {
                        const foundM = markerTimes.includes(region.start) || markerTimes.includes(region.end);
                        if(foundM){foundMatch++}
                    });

                    if(foundMatch > 0){
                        Object.keys(wavesurfer.regions.list).forEach((id) => {
                                wavesurfer.regions.list[id].remove();
                        });
                    }

                }
            })

            // waveform Selection
            wavesurfer.on('region-updated', (newRegion) => {
                var regionTime = document.getElementById('regionTime');
                regionTime.innerText = `Selection: ${formatTime(newRegion.end - newRegion.start)}`;
            })
            // remove previous region (1 region at once)
            wavesurfer.on('region-created', (newRegion) => {              
                Object.keys(wavesurfer.regions.list).forEach((id) => {
                    if(wavesurfer.regions.list[id] !== newRegion){
                        wavesurfer.regions.list[id].remove();
                    }
                });
                // Removes region on right-click
                newRegion.element.addEventListener('contextmenu', (e) => {
                    e.preventDefault();
                    resetSelectionTime();
                    newRegion.remove(); 
                });

                newRegion.on('out', () => {
                    playbackFinished = true;
                    fileplaying = '';
                    if(loop){
                        playerPlayPause(); 
                    } else {
                        playerStop()
                        playIconDefault();
                    }

                });
            });

            wavesurfer.on('marker-click', (marker) => {

            })
            
            wavesurfer.on('ready', function (){

                const audioBuffer = wavesurfer.backend.buffer;

                numChannels = audioBuffer.numberOfChannels;
                rememberData.sampleRate = parseInt(audioBuffer.sampleRate)
                //if(isStereo){
                    wavesurfer.params.height = PlayerHeight / numChannels;
                /*} else {
                    wavesurfer.params.height = PlayerHeight;
                }*/
                wavesurfer.params.barHeight = Vzoom ? Vzoom : 1;
                var vzoomEl = document.getElementById('zoomVerticalSlider');
                vzoomEl.value = Vzoom ? Vzoom : 1;
                var zoom = document.getElementById('zoomSlider');

                zoom.value = 40;
                wavesurfer.zoom(0)

                /* rwemove the previous region */
                Object.keys(wavesurfer.regions.list).forEach((id) => {
                    wavesurfer.regions.list[id].remove();
                });

                document.getElementById('loadingWaveform').style.display = 'none';

                //downloadIcon(s3filename)

                markersArray?.forEach((marker) => {

                    wavesurfer.addMarker({
                        time: marker.time,
                        label: marker.label,
                        color: '#F00',
                        position: 'top',
                        draggable: true,
                        tooltip: marker.label,
                        preventContextMenu: true

                    });
                })

                howManyMarkerAtTheBegin = markersArray?.length ?? 0

                const audioDuration = wavesurfer.getDuration()
                timeDuration.textContent = formatTime(audioDuration)
                zoomMax = calculateZoomMax(audioDuration); // Esempio di formula adattiva
                $('#zoomSlider').attr('max', zoomMax);
                listOfMarkers()
                
                setTimeout(function(){
                    wavesurfer.play();
                    playerStatus()
                }, 300)
            })

            wavesurfer.on('play', function(){
                playbackFinished = false;
            });

            wavesurfer.on('seek', function(){
                const currentPosition = wavesurfer.getCurrentTime();
                timercursor.textContent = formatTime(currentPosition);

                if(!playbackFinished){
                    Object.keys(wavesurfer.regions.list).forEach(function (id){
                        const regione = wavesurfer.regions.list[id];
                        if(currentPosition >= regione.start && currentPosition <= regione.end){} else {
                            resetSelectionTime()
                            wavesurfer.regions.list[id].remove();
                        } 
                    });
                }
                playbackFinished = false;
            });

            wavesurfer.on('finish', function (){
                playbackFinished = true;
                fileplaying = '';
                if(loop){
                    playerPlayPause()
                } else {
                    playIconDefault()
                    playerBackward()
                }
            })
            
            wavesurfer.on('error', function (error){

                howManyMarkerAtTheBegin = 0;
                listOfMarkers()
            })
         
            wavesurfer.on('audioprocess', () => {
                const currentPosition = wavesurfer.getCurrentTime();
                timercursor.textContent = formatTime(currentPosition);
            })

        }).catch((error) => {
            //console.log(error)
            elementLoading.innerHTML = `Error`;
        });
    }
    FetchAudioFile()
}

const notSaved = () => {
    if(allowMarkersVar){
        wavesurfer.setWaveColor('#ff0000');
        wavesurfer.setBackgroundColor('#4b1010');
        $('#saveMarkersButton').show();      
    }
}

const hideSaveButton = (changeColor) => {
    if(changeColor){
        wavesurfer.setWaveColor(rememberData.waveColor);
        wavesurfer.setBackgroundColor(rememberData.backgroundColor);
    }
    $('#saveMarkersButton').html('Save').removeClass('disabled').hide();
}

function deleteMarker(id){
    const newMarker = wavesurfer.markers.markers.filter((marker) => marker.time !== id)
    wavesurfer.clearMarkers()
    newMarker.forEach((marker) => {
        createNewMarker(marker)
    })
    listOfMarkers()
    if(howManyMarkerAtTheBegin === 0 && newMarker.length === 0){
        hideSaveButton(true)
        return 
    }
    notSaved()
}

window.deleteMarker = deleteMarker
window.editMarker = editMarker
window.changeLabelName = changeLabelName

function editMarker(element, time){
    const currentElement = $(element);
    if($('#newMarker').length === 1){
        return
    }
    const text = $.trim(currentElement.text());
    const textLabel = text !== '' ? text : 'No Name';
    currentElement.html('<input type="text" id="newMarker" class="form-control" value="' + textLabel + '" onblur="changeLabelName(this, ' + time + ')" autocomplete="off">');
    $('#newMarker').focus();
}



function changeLabelName(element, time){

    const currentElement = $(element);
    const newName = $.trim(currentElement.val());
    const assignName = newName !== '' ? newName : 'No Name';

    const newMarker = wavesurfer.markers.markers.map((marker) => {
        if(marker.time === time){
            return {
                ...marker,
                label: assignName,
                popup: assignName              
            }
        }
        return marker
    })

    wavesurfer.clearMarkers()
    newMarker.forEach((marker) => {
        createNewMarker(marker)
    })
    listOfMarkers()
    notSaved()
}


const listOfMarkers = (props) => {
    const markerList = $('.markerList tbody')
    markerList.html('');
    const markersObject = props ?? wavesurfer.markers.markers
    if(markersObject.length === 0){
        markerList.append('<div class="no-markers">No markers</div>')
        return
    }

    const sortedMarkers = markersObject.slice().sort((a, b) => a.time - b.time)

    sortedMarkers.forEach((marker, idx) => {
        markerList.append(`<tr>
                            <td style="cursor: pointer;">
                                <span onclick="editMarker(this, ${marker.time})">${marker.label}<span>
                            </td>
                            <td width="70">${formatTime(marker.time)}</td>
                            <td width="25">
                                <i class="bi bi-trash trashCursor" title="Delete Marker" onclick="deleteMarker(${marker.time})"></i>
                            </td>
                            </tr>`)
    })
}



function openCloseMarkersWindow (){

    if(!allowMarkersVar){
        return
    }

    let reduceOf = 125   
               
    if(document.getElementById('markerListPanel').style.display !== 'block'){
        document.getElementById('markerListPanel').style.display = 'block';
        reduceOf = reduceOf + 160
    } else {
        document.getElementById('markerListPanel').style.display = 'none';
        
    }

    if(portal){
        const widndowHeight = $(window).height();
        let playerHeight = widndowHeight - reduceOf

        playerHeight = playerHeight/numChannels

        wavesurfer.setHeight(playerHeight)
        $('#waveform').height(widndowHeight - reduceOf)
        //wavesurfer.drawBuffer(); 
        redrawWaveform();
    }
}



export const playAudioSpace = (s3filename, type, realFilename, height, fromManualPlay) => {
    playerPlayPause()
}

function loopAudio(){
    loop = !loop
    if(loop){
        $('#loopBotton').addClass('active')
    } else {
        $('#loopBotton').removeClass('active')
    }
}


function backgroundPlay(status){
    var playButton = document.getElementById('PlayButton');
    if(status === false){
        playButton.classList.remove('active');
    } else {
        playButton.classList.add('active');
    }
}

$(document).off('change','#volume').on('change','#volume', function(){
    try{
        //wavesurfer.setVolume($('#volume').val());
    }catch(e){}
});

function playerStatus(){
    var changeIconPlayer = document.getElementById('changeIconPlayer');

    if(wavesurfer.isPlaying()){
        changeIconPlayer.classList.remove('bi-pause');
        changeIconPlayer.classList.add('bi-play');
    } else {
        changeIconPlayer.classList.remove('bi-play');
        changeIconPlayer.classList.add('bi-pause');
    }

    backgroundPlay(true);
}

function playIconDefault(){
    var changeIconPlayer = document.getElementById('changeIconPlayer');

    changeIconPlayer.classList.remove('bi-pause');
    changeIconPlayer.classList.add('bi-play');

    backgroundPlay(false);
}

function playerPlayPause(){
    try{
        // Check if at least one region exists
        const regions = Object.keys(wavesurfer.regions.list);
        if(regions.length > 0){
            // take info from the regione 
            const region = wavesurfer.regions.list[regions[0]];
                wavesurfer.pause();
                // Riproduci solo la regione selezionata
                region.play();
        } else {
            wavesurfer.playPause();
        }
        playerStatus();
    } catch(err){}
}

const createNewMarker = (props) => {
    const currentMarkers = props ?? JSON.parse(JSON.stringify(wavesurfer.markers.markers)); //wavesurfer.markers.markers

    const name = $('#markerNameDefault').val()
    wavesurfer.addMarker({
        time: props ? props.time : wavesurfer.getCurrentTime(),
        label: props ? props.label : name !== '' ? name : `Label ${currentMarkers.length + 1}`,
        color: '#F00',
        position: 'top',
        draggable: true
    });

    if(!props){
        notSaved()
        listOfMarkers()
    }
}

 
function playerStop(){
    wavesurfer.stop();
    playIconDefault()
}

function playerBackward(){
    wavesurfer.seekTo(0);
}

export const amplayerBackward = () =>{
    playerBackward()
}

const resetSelectionTime = () => {
    var regionTime = document.getElementById('regionTime');
    regionTime.innerHTML = "";
}



function formatTime(seconds){
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const milliseconds = Math.floor((seconds - Math.floor(seconds)) * 1000);
  
    let formattedTime = '';
  
    if(hours > 0){
        formattedTime += `${hours.toString().padStart(2, '0')}:`;
    }
  
    formattedTime += `${minutes.toString().padStart(2, '0')}:`;
    formattedTime += `${remainingSeconds.toString().padStart(2, '0')}`;
    

    formattedTime += `.${milliseconds.toString().padStart(3, '0')}`;

  
    return formattedTime;
}


function eleboratePlayList(data, index){

    data[index].active = true

    return data
}

//function downloadIcon(string){
//    let allowDownload = 0
//
//    if(string.includes("/source/") && permissions?.SourceDownloadFiles){
//        allowDownload++
//    }
//    if(string.includes("/target/") && permissions?.TargetDownloadFiles){
//        allowDownload++
//    }
//    if(allowDownload > 0){
//        enableDownload = true
//        $('.downloadHandler').show()
//    } else {
//        enableDownload = false
//        $('.downloadHandler').hide()
//    }
//}





/* open Player for Modal */
export const visiblePlayer = () => {
    $('#playerContainer').show();
    $('#playerContainer').addClass('portal');
    portal = true
}

/* hide player in script */
export const hidePlayer = () => {
    $('#playerContainer').hide();
}

/* restore the player */
export const recallStandardPlayer = () => {
    $('#playerContainer').show();
}

function calculateZoomMax(durationInSeconds){
    // Stabilisce i valori di zoom massimo per 1 secondo e per 60 secondi (1 minuto)
    const zoomForOneSecond = 10000;
    const zoomForSixtySeconds = 1000;
  
    // Calcola un fattore di scala basato sulla durata
    let scale = zoomForSixtySeconds + (zoomForOneSecond - zoomForSixtySeconds) * ((60 - durationInSeconds) / 60);
    
    // Assicura che il valore sia all'interno dei limiti stabiliti
    scale = Math.min(zoomForOneSecond, scale);
    scale = Math.max(zoomForSixtySeconds, scale);
  
    return parseInt(scale);
}


const availableFormatsButtons = (availableFormats, current, s3filename, type, realFilename, height, fromManualPlay, localAudio) => {

   
    const extensionLists = availableFormats.sort((a, b) => a.localeCompare(b))
    const supportedFormats = extensionLists.filter((el) => !unsupportedFormats.includes(el))

    const forcePlayFormat = (type) => {
        const forceName = s3filename.split('.')[0] + "." + type
        playAudio(s3filename, type, realFilename, height, fromManualPlay, localAudio, forceName)
    }
    
    const formatsDiv = document.getElementById('availableFormats');
    formatsDiv.innerHTML = '';
    if (supportedFormats.length !== 1) {
        const group = document.createElement('div');
        group.className = 'btn-group';
        group.setAttribute('role', 'group');
    
        supportedFormats.forEach((el) => {
            const btn = document.createElement('button');
            const selected = current.endsWith(el);
            const isOptimized = s3filename.endsWith(el);
            btn.className = `extension-format-play-buttons ${isOptimized ? '' : 'optimized '}btn btn-sm btn${selected ? '' : '-outline'}-primary`;
            btn.textContent = el;       
            if (!selected) {
                btn.addEventListener('click', () => forcePlayFormat(el));
            }
    
            group.appendChild(btn);
        });    
        formatsDiv.appendChild(group);
    }
}


export const AudioQualityButton = (props) => {

    const [hiquality, setHiQuality] = useState(props.audioQuality ?? true)
    const noBorder = props.noBorder;

    const stylePlaceHolders = {
        width: "25px", 
        position: "relative",
        display: "inline-block"
    }

    const handleHiquality = (prop) => {
        switchQuality++
        setHiQuality(prop)
    }

    const qualityColor = {
        color: hiquality ? '#FFF' : '#FFF',
        borderColor: hiquality ? '#0d6efd' : '#d1886b',
        background: hiquality ? '#0d6efd' : '#fd8153'
    }
    useHQFiles = hiquality

    return <><button 
                id="audioQualityButton"
                quality={hiquality ? 'hiquality' : 'lowquality'}
                className="btn btn-outline-primary btn-sm" 
                style={{...qualityColor, marginLeft: -1, borderRadius: noBorder ? '0px' : '0px 4px 4px 0px'}}
                onClick={() => {}}
                data-bs-toggle="dropdown"
                >
                <i className="ri-headphone-line"></i>
            </button>
            <ul className="dropdown-menu audioQuality">
                <b>Audio Quality</b>
                <li className="dropdown-item" onClick={() => handleHiquality(true)}>
                    <span style={stylePlaceHolders}>{hiquality && <Check />}</span>
                    Original Quality
                </li>
                <li className="dropdown-item" onClick={() => handleHiquality(false)}>
                    <span style={stylePlaceHolders}>{!hiquality && <Check />}</span>
                    Optimized
                </li>

            </ul></>
}

const Check = () => {
    return <i className="ri-check-line" style={{position: "relative", top: "5px"}}></i>
} 


const checkMarkers = (playerM, originalM) => {

    if(!originalM){
        return 
    }

    if(playerM.length !== originalM.length){
        return 'changed'
    }

    const checkMarkers = {}
    originalM.forEach((el) => {
        checkMarkers[`${el.label}::${el.time}`] = true
    })

    let found = 0; 

    playerM.forEach((el) => {
        if(checkMarkers[`${el.label}::${el.time}`]){
            found++
        }
    })

    if(found === originalM.length){
        return 'ok'
    }
    else{
        return 'changed'
    }
}

